import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csidentifier(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free JavaScript Identifier Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript identifier tutorial for beginners identifier in Javascript blank space special symbol is not allowed ,it must begin with a letters" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Javascript identifier,javascript unexpected identifier,javascript identifiers,javascript identifier expected,Javascript foreach identifier" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-identifier" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Javascript identifier </h1>
    <div className="first">
        <a href="/javascript-comment">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Identifier In Javascript:</h2>
    <p className="mt-4 para"><span className="bold">1, Identifier In Javascript</span> is a name given to a variable method.<br/>
2, Blank space special symbol is not allowed <br/>
3, It must begin with letters<br/>
4, You don’t use any keyword in the same manner means or Uppercase and lowercase are different means <br/>
</p>


<h2 className="headings">
        Uppercase and lowercase in Javascript Example:
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}

            <span className="qwerty-10">my_name</span>

            {"\n"}
            <span className="qwerty-4">My_Name</span>

            {"\n"}

            {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Rules of identifier in Javascript :</h2>
<h3  className="mt-4 mh3"> 1, Blank Space Special Symbol in Javascript</h3>



        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
    {"\n"}
         
            <span className="qwerty-10">code-exampler</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">false </span>
            {"\n"}
            <span className="qwerty-4">code.exampler</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">false </span>
            {"\n"}
            <span className="qwerty-10">code_exampler</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-3">true </span>
            {"\n"}
            <span className="qwerty-4">codeexampler</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-3">true </span>
            {"\n"}
            <span className="qwerty-10">code exampler</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">false </span>
            {"\n"}
          {"\n"}
        
            </code>
          </pre>        
        </div>

<h3 className="mt-4 mh3">2, It Must Begin With Letters Identifier in Javascript Example:</h3>



        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
    {"\n"}
         
            <span className="qwerty-4">var</span>
            <span className="qwerty-8">-</span>
            <span className="qwerty-3">2a;</span>
            <span className="qwerty-8">-</span>
            <span className="qwerty-1">False </span>
            {"\n"}
            <span className="qwerty-4">var </span>
            <span className="qwerty-3">a2</span>
            <span className="qwerty-8">-</span>
            <span className="qwerty-10">True </span>
            {"\n"}
            <span className="qwerty-4">var </span>
            <span className="qwerty-3">_24a;</span>
            <span className="qwerty-8">-</span>
            <span className="qwerty-1">False </span>
            {"\n"}
    
        
                {"\n"}
        
        
        
           
            </code>
          </pre>        
        </div>

<h3 className="mt-4 mh3">3, We Don’t use any Reserved keyword means:<br/></h3>


        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
    {"\n"}
         
            <span className="qwerty-4">var </span>
            <span className="qwerty-3">if;</span>
            <span className="qwerty-8">-</span>
            <span className="qwerty-1">false </span>
            {"\n"}
            <span className="qwerty-4">var </span>
            <span className="qwerty-3">IF;</span>
            <span className="qwerty-8">-</span>
            <span className="qwerty-10">true </span>
            {"\n"}
    
        
                {"\n"}
        
        
        
           
            </code>
          </pre>        
        </div>

<h3 className="mt-4 mh3">4, We only type less than 31 characters long <br/></h3>


        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
    {"\n"}
         
            <span className="qwerty-4">var </span>
            <span className="qwerty-3">a;</span>
            <span className="qwerty-10">{`//this declares a variable means a is a variable`} </span>
            {"\n"}
            <span className="qwerty-3">a</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">4; </span>
            <span className="qwerty-10">{`//this assigns 4 to (a) means assigns a variable a value`} </span>
            {"\n"}
    
        
                {"\n"}
        
        
        
           
            </code>
          </pre>        
        </div>


  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/javascript-comment">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csidentifier;